import { AxiosRequestConfig } from "axios";

import { axiosInstance } from "../api/axiosConfig";
import { addConnectedKeys, ExchangeKey, isDexieEnabled } from "../db";
import { ExchangeKeyQueries } from "../db/quries";
import { setConnectedKeys, setSelectedExchange, toggleLoadingKeys } from "../redux/exchange-switcher.slice";
import { store } from "../redux/store";

export const getConnectedProviders = async (options: AxiosRequestConfig) => {
  ExchangeKeyQueries.getExchangeKeys((data) => {
    if (data.exchangeKeys != null) {
      store.dispatch(setConnectedKeys(data.exchangeKeys.sort((a, b) => a.provider_id < b.provider_id ? 1 : -1)));
      if (data?.selectedExchange?.length && data.exchangeKeys.find(e => e.name === data?.selectedExchange?.[0].name && e.provider_id === data.selectedExchange?.[0].provider_id))
        store.dispatch(
          setSelectedExchange(data.selectedExchange[0]),
        );
      else
        store.dispatch(
          setSelectedExchange(data.exchangeKeys.find(e => e.exchange_key_id == null) as ExchangeKey),
        );
      store.dispatch(toggleLoadingKeys(false))
    }
  })

  const data = await axiosInstance.get(`/exchange/connected-keys`, options);
  addConnectedKeys(data.data.data)
  if (!isDexieEnabled()) {
    // Dexie is off: mirror the cache read path (ExchangeKeyQueries) so the UI
    // behaves identically — sort keys by provider_id, and default the selected
    // exchange to the aggregate ("All", exchange_key_id == null) rather than the
    // last key. The dashboard's initial holdings call keys off the selected
    // exchange, so defaulting to the aggregate is what fetches the full
    // portfolios array that populates the Providers table.
    const keys: ExchangeKey[] = [...data.data.data].sort((a, b) =>
      a.provider_id < b.provider_id ? 1 : -1,
    );
    store.dispatch(setConnectedKeys(keys));
    if (keys.length)
      store.dispatch(
        setSelectedExchange(
          keys.find((e) => e.exchange_key_id == null) ?? keys[keys.length - 1],
        ),
      );
    store.dispatch(toggleLoadingKeys(false));
  }
  return data.data;
};

export const getAvailableProviders = async (options: AxiosRequestConfig) => {
  return await axiosInstance.get("/general/providers", options);
};

export const addPaperAccount = async (options: AxiosRequestConfig) => {
  const data = {
    ...options.data,
    account_type: "paper",
  };

  return await axiosInstance.post(`/exchange/keys`, data, options);
};

export const manageExchangeKey = async (options: AxiosRequestConfig) => {
  const data = {
    ...options.data,
    account_type: "exchange",
  };
  return await axiosInstance.post("/exchange/keys", data, options);
};

export const refreshKeys = async (options: AxiosRequestConfig) => {
  return await axiosInstance.get("/exchange/keys/refresh", options);
};

export const testKey = async (options: AxiosRequestConfig) => {
  return await axiosInstance.get("/exchange/keys/test", options);
};

export const getDustAssets = async (options: AxiosRequestConfig) => {
  return axiosInstance.get("trade-engine/dust", options);
};

export const convertDust = async (
  providerId: number,
  assetsSymbols: string[],
) => {
  return axiosInstance.put(
    `trade-engine/dust/convert?exchange_key_id=${providerId}`,
    {
      assets: assetsSymbols,
    },
  );
};
